export const normalizeNull = <T>(value: T | string): T | null => {
    if (value === 'null') return null;
    return value as T;
};
